import React, { useRef, useEffect, useState, useContext } from 'react';
import { DataContext } from 'contexts/DataContext';
import { GridColDef } from '@mui/x-data-grid';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Business from "@mui/icons-material/Business";
import Add from '@mui/icons-material/Add';
import ModalTitle from 'components/ModalTitle/ModalTitle';

import EditableGrid from 'components/EditableGrid/EditableGrid';
import { get, update, destroy, getColumns } from './departments_api';
import 'i18n/config';
import { useTranslation } from 'react-i18next';
import Users from './Users';

interface DetailProps {
    master?: any;
    row: any;
  }
  
  function Department(props:DetailProps){
    const { t } = useTranslation();
    const dataContext = useContext(DataContext);
    const addButtonRef = useRef(null);
    const [columns, setColumns] = useState([] as GridColDef[]);
    useEffect(() => {
      if(dataContext.loading) return;
      getColumns(dataContext.language).then((response) => {
        setColumns(response);
      });
    }, [dataContext.loading, dataContext.language]);
    return (
      <>
         <ModalTitle title={
          <>
            <Business />
            <Typography variant="pageTitle" component="h1" gutterBottom>
            {props.row.name}
            {' > '} 
            {t('Departments')}
            </Typography>
          </>
         } 
         actions={[
          {
            label: t('Add department'),
            icon:<Add />,
            action: () => {
              let addbutton = addButtonRef.current as any;
              addbutton.click();
            }
          }
        ]}
        />
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              padding: '30px',
              backgroundColor: (theme) => theme.palette.background.default,
            }}
          >
          {columns.length > 0 &&
          <EditableGrid addButtonRef={addButtonRef} hideAddButton={true}  details={Users} master={props.row} columns={columns} get={get} update={update} delete={destroy}
          name='departmentGrid'
          detailsWidth='66%'
          labels={{
            "actions": t('Actions'),
            "add": {
              "button": t("Add department")
            },
            "details": {
              "column":t('Users'), 
              "button":t('View')
            }
          }} />}
          </Box>
      </>
    )
  }

export default Department;